
const DuplicateTreatment = {
	mounted() {
		this.el.addEventListener("change", e => {
			if(this.el.checked) {
				this.pushEvent("checked-dt", {dt: this.el.value});
			} else {
				this.pushEvent("unchecked-dt", {dt: this.el.value});
			}
		})
	}
};

export default DuplicateTreatment;
